module.exports = __webpack_public_path__ + "static/media/courseaddswap.f3d1321e.pdf";